var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditorMenuBubble',{staticClass:"toolbar__group",attrs:{"editor":_vm.editor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var commands = ref.commands;
var getMarkAttrs = ref.getMarkAttrs;
return [_c('EditTextButton',[_c('ZyroColorPicker',{attrs:{"value":getMarkAttrs(_vm.COLOR_MARK_NAME).color || 'var(--colors-light)'},on:{"input":function($event){return commands.color({ color: $event })}}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }